var map = {
	"./10-gm-achieved.png": 407,
	"./10-gm-unachieved.png": 122,
	"./404.png": 268,
	"./502.png": 269,
	"./Arrow Back2x.png": 408,
	"./Astra/Retailer/R0.png": 109,
	"./Astra/Retailer/R10.png": 181,
	"./Astra/Retailer/R100.png": 182,
	"./Astra/Retailer/R20.png": 183,
	"./Astra/Retailer/R30.png": 184,
	"./Astra/Retailer/R40.png": 185,
	"./Astra/Retailer/R50.png": 186,
	"./Astra/Retailer/R60.png": 187,
	"./Astra/Retailer/R70.png": 188,
	"./Astra/Retailer/R80.png": 189,
	"./Astra/Retailer/R90.png": 190,
	"./Astra/Sale/S0.png": 108,
	"./Astra/Sale/S10.png": 191,
	"./Astra/Sale/S100.png": 192,
	"./Astra/Sale/S20.png": 193,
	"./Astra/Sale/S30.png": 194,
	"./Astra/Sale/S40.png": 195,
	"./Astra/Sale/S50.png": 196,
	"./Astra/Sale/S60.png": 197,
	"./Astra/Sale/S70.png": 198,
	"./Astra/Sale/S80.png": 199,
	"./Astra/Sale/S90.png": 200,
	"./Astra/Service/SE0.png": 110,
	"./Astra/Service/SE10.png": 201,
	"./Astra/Service/SE100.png": 202,
	"./Astra/Service/SE20.png": 203,
	"./Astra/Service/SE30.png": 204,
	"./Astra/Service/SE40.png": 205,
	"./Astra/Service/SE50.png": 206,
	"./Astra/Service/SE60.png": 207,
	"./Astra/Service/SE70.png": 208,
	"./Astra/Service/SE80.png": 209,
	"./Astra/Service/SE90.png": 210,
	"./Astra/a.png": 298,
	"./Astra/blueline.png": 299,
	"./Astra/brownline.png": 300,
	"./Astra/greenline.png": 301,
	"./BKB-Elements/Asta Hole.png": 409,
	"./BKB-Elements/Astra bg.png": 410,
	"./BKB-Elements/Bg img 2.png": 411,
	"./BKB-Elements/Final milestone.png": 412,
	"./BKB-Elements/FullStone.png": 180,
	"./BKB-Elements/Group 12090.png": 413,
	"./BKB-Elements/Rank.png": 170,
	"./BKB-Elements/Rank_top_nav_bar_bg2.png": 414,
	"./BKB-Elements/Rank_top_nav_bar_button.png": 137,
	"./BKB-Elements/bg.png": 415,
	"./BKB-Elements/bg_astra.png": 416,
	"./BKB-Elements/bg_new.png": 136,
	"./BKB-Elements/full_stone.png": 318,
	"./BKB-Elements/ok_button.png": 319,
	"./BKB-Elements/points-bar.png": 417,
	"./BKB-Elements/points_bar.png": 418,
	"./Calendar-icon.png": 149,
	"./Cash_Collection.png": 277,
	"./Daily_invest.png": 279,
	"./Impact_player_screen/CompletedAstra/blank.png": 320,
	"./Impact_player_screen/CompletedAstra/unnamed.png": 419,
	"./Impact_player_screen/CompletedAstra/with_text.png": 215,
	"./Impact_player_screen/CompletedAstra/with_text_old.png": 420,
	"./Impact_player_screen/Onboarding_screen/Screen2.png": 321,
	"./Impact_player_screen/Onboarding_screen/normal_day.png": 176,
	"./Impact_player_screen/Onboarding_screen/two_days_back.png": 216,
	"./Impact_player_screen/home_screen/ArrowBack.png": 322,
	"./Impact_player_screen/home_screen/Back_to_Home.png": 323,
	"./Impact_player_screen/home_screen/Border_daily_points.png": 138,
	"./Impact_player_screen/home_screen/Daily_total_points_bg.png": 421,
	"./Impact_player_screen/home_screen/EnterBKB.png": 324,
	"./Impact_player_screen/home_screen/Group 12457.png": 422,
	"./Impact_player_screen/home_screen/Group 12462.png": 423,
	"./Impact_player_screen/home_screen/Group_12509.png": 290,
	"./Impact_player_screen/home_screen/Impact ranking.png": 424,
	"./Impact_player_screen/home_screen/Timer.png": 425,
	"./Impact_player_screen/home_screen/bg_daily_points.png": 426,
	"./Impact_player_screen/home_screen/claim_2x.png": 325,
	"./Impact_player_screen/home_screen/impact_player.png": 427,
	"./Impact_player_screen/home_screen/impact_player_bonus.png": 428,
	"./Impact_player_screen/home_screen/mumbai.png": 130,
	"./Impact_player_screen/home_screen/next_icon.png": 217,
	"./Impact_player_screen/home_screen/points_bg.png": 429,
	"./Impact_player_screen/home_screen/ranking_bg.png": 219,
	"./Impact_player_screen/live.png": 175,
	"./Individual_leaderboard.png": 169,
	"./Normal-dist/Arrow_back.png": 326,
	"./Normal-dist/Rectangle_bg_1.png": 430,
	"./Normal-dist/Rectangle_blue_2.png": 431,
	"./Normal-dist/Rectangle_yellow_2.png": 432,
	"./Normal-dist/retailer_astra_btn.png": 433,
	"./Normal-dist/retailer_astra_btn_1.png": 434,
	"./Normal-dist/saleastra_bg.png": 435,
	"./Normal-dist/saleastra_btn.png": 436,
	"./Normal-dist/service_astra.png": 437,
	"./Normal-dist/service_astra_btn.png": 438,
	"./Payment_Gateway.png": 278,
	"./Point-logo.png": 53,
	"./Points-box.png": 98,
	"./See-all.png": 439,
	"./Utility.png": 158,
	"./WarLeaderboard.png": 440,
	"./Wars-won-icon.png": 273,
	"./aeps.png": 159,
	"./all_rounder.png": 441,
	"./atm.png": 160,
	"./awtar-image.png": 221,
	"./back-blue.png": 119,
	"./back.png": 37,
	"./bg.png": 442,
	"./bill_payment.png": 443,
	"./bkb-header.png": 289,
	"./bkb-leaderboard-header.png": 444,
	"./bkb3-gifts.png": 218,
	"./cannonsmallbottomnew.png": 99,
	"./canonbigbottom.png": 100,
	"./canonsmallbottom.png": 445,
	"./cash_rotation_bonus.png": 446,
	"./cashdrop.png": 447,
	"./chat_black.png": 448,
	"./clock.png": 449,
	"./close.png": 45,
	"./congo-profile.png": 254,
	"./congratulation.png": 253,
	"./crown.png": 248,
	"./daily_invest.png": 450,
	"./datebox.png": 293,
	"./defaultProfile.png": 43,
	"./dhanak.png": 157,
	"./dhanakHub.png": 281,
	"./dhanakRefurb.png": 280,
	"./dhanak_accessories.png": 451,
	"./dmt.png": 161,
	"./down-thumb.png": 252,
	"./down.png": 64,
	"./downLoadMore.png": 452,
	"./dpos.png": 453,
	"./dth.png": 275,
	"./faq-icon.png": 94,
	"./faq.png": 60,
	"./faq1.png": 257,
	"./flight.png": 276,
	"./flights.png": 263,
	"./gatway.png": 454,
	"./gatway_portal.png": 455,
	"./group-chat-arrow.png": 148,
	"./icons-transaction-pending/aeps.png": 302,
	"./icons-transaction-pending/bill_payment.png": 303,
	"./icons-transaction-pending/cashdrop.png": 304,
	"./icons-transaction-pending/daily_invest.png": 305,
	"./icons-transaction-pending/dhanak.png": 306,
	"./icons-transaction-pending/dmt.png": 307,
	"./icons-transaction-pending/dpos.png": 308,
	"./icons-transaction-pending/flights.png": 309,
	"./icons-transaction-pending/gatway.png": 310,
	"./icons-transaction-pending/irctc.png": 311,
	"./icons-transaction-pending/micro_atm.png": 312,
	"./icons-transaction-pending/mpos.png": 313,
	"./icons-transaction-pending/pan_card.png": 314,
	"./icons-transaction-pending/ppi.png": 315,
	"./icons-transaction-pending/recharge.png": 316,
	"./icons-transaction-pending/trans_pending.png": 131,
	"./icons-transaction-pending/utility.png": 317,
	"./impact.png": 165,
	"./impact_bonus.png": 456,
	"./inReview.png": 117,
	"./insurance.png": 457,
	"./irctc.png": 282,
	"./jarvis/png/chatbot.png": 96,
	"./jarvis/png/graph_placeholder.png": 222,
	"./jarvis/png/graph_placeholder_1.png": 223,
	"./jarvis/png/jarvis_bg.png": 112,
	"./jarvis/png/table_placeholder.png": 224,
	"./jarvis/png/user.png": 139,
	"./kingdom.png": 458,
	"./leaderboard.png": 459,
	"./left-arrow-black.png": 120,
	"./level-icon.png": 460,
	"./live.png": 292,
	"./lock.png": 461,
	"./lose-profile.png": 256,
	"./lose.png": 255,
	"./loser.png": 462,
	"./lost-icon.png": 251,
	"./membership.png": 463,
	"./micro_atm.png": 464,
	"./middle-icon.png": 465,
	"./mpos.png": 466,
	"./other.png": 93,
	"./pan_card.png": 283,
	"./ppi.png": 467,
	"./recharge.png": 162,
	"./refresh.png": 247,
	"./right-arrow.png": 147,
	"./right-white.png": 163,
	"./right.png": 468,
	"./saarthi_bonus.png": 469,
	"./saarthi_bonus_points.png": 470,
	"./search.png": 274,
	"./send.png": 244,
	"./share-kd-right.png": 164,
	"./share.png": 272,
	"./slider-bkb.png": 265,
	"./slider-kingdom.png": 266,
	"./slider-war.png": 267,
	"./sort-icon.png": 471,
	"./standings.png": 472,
	"./stat-arrow-red.png": 103,
	"./stat-arrow.png": 104,
	"./stats.png": 473,
	"./thumb.png": 250,
	"./tips_and_updates.png": 474,
	"./topup.png": 475,
	"./up.png": 30,
	"./upLoadMore.png": 476,
	"./utility (2).png": 477,
	"./utility.png": 478,
	"./utility_portal.png": 479,
	"./war-began.png": 480,
	"./war.png": 481,
	"./war_points.png": 264,
	"./warzone-icon.png": 258,
	"./wealth-Icon.png": 482,
	"./winner.png": 483,
	"./won-icon.png": 249,
	"./you-lose-home.png": 145,
	"./you-lose-war-page.png": 484,
	"./you-won-home.png": 144,
	"./you-won-war-page.png": 485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 406;